export default __webpack_public_path__ + "static/media/tabee_firm.99d69222.svg";